export const baseUrlDev = 'https://apidev.soba.africa/api/';
export const baseUrlPro = 'https://soba-api-v1.soba.africa/api/';